import React from 'react';
import List from 'components/list/List';
import { Guide } from 'types/guide';
import GuideItemModule from './GuideItemModule';
import GuideMenu from '../menu/GuideMenu';
import { useGuide } from '../../hooks/useGuide';

interface GuideListModuleProps {
  guides: Guide[];
}

const GuideListModule: React.FC<GuideListModuleProps> = ({ guides }) => {
  const { anchorEl } = useGuide();

  return (
    <>
      {anchorEl && <GuideMenu anchorEl={anchorEl} />}
      <List>
        {guides.map(guide => (
          <GuideItemModule key={guide.id} guide={guide} />
        ))}
      </List>
    </>
  );
};

export default GuideListModule;
